import { Button, ModalDialog, ModalOverlay } from '@flos/react-ui';
import { useHippoText } from '../../hooks/useHippoText';

const CHAModal = ({
    showModal,
    closeModal
}: {
    showModal: boolean;
    closeModal: () => void;
}): React.JSX.Element => {
    const getHippoText = useHippoText();

    return (
        <ModalOverlay isOpen={showModal}>
            <ModalDialog closeIconHandler={closeModal}>
                <div className="u-spacing-inset-l">
                    <div className="u-spacing-inset-l--stretch-max">
                        <h4 className="u-spacing-stack-sm">
                            {getHippoText('DSS-CHA-MODAL-HEADER')}
                        </h4>
                        <p className="u-spacing-stack-sm">
                            {getHippoText('DSS-CHA-MODAL-DESCRIPTION')}
                        </p>
                    </div>
                    <Button onClick={closeModal}>{getHippoText('DSS-CHA-MODAL-CONTINUE')}</Button>
                </div>
            </ModalDialog>
        </ModalOverlay>
    );
};

export default CHAModal;
